import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useCurrentTalentProfile } from "../../../hooks";
import { useGetATalent } from "../../../services/api/talent.api";

import TalentSettingsPage from "./TalentSettingPage"; // main settings page component

// —— Netflix-ish tokens (visual only)
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  text: "#ffffff",
  muted: "rgba(255,255,255,0.75)",
  border: "rgba(255,255,255,0.12)",
  red: "#E50914",
};

/* ---------------------------------- */
export default function TalentSettingsWrapper() {
  const { currentProfile } = useCurrentTalentProfile();

  const { data: talent, isLoading } = useGetATalent({
    key: ["talent", currentProfile?.id],
    params: { id: Number(currentProfile?.id) },
    options: { enabled: !!currentProfile?.id },
  });

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        mt={6}
        sx={{ backgroundColor: COLORS.bg, minHeight: "100vh" }}
      >
        <CircularProgress sx={{ color: COLORS.red }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        backgroundColor: COLORS.bg,
        color: COLORS.text,
        minHeight: "100vh",
      }}
    >
      {/* ---------- Body ---------- */}
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
        <TalentSettingsPage talentInfo={talent!.data} />
      </Box>
    </Box>
  );
}
